
export function isEmpty(aString?: string): boolean {
  return !aString || !aString.trim();
}
